import contentDisposition from 'content-disposition';
import api from './api';

class FileDownloader {
  async downloadFile(input: RequestInfo, init?: RequestInit) {
    const { fileName, blob } = await this.getFile(input, init);
    // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
      return;
    }

    // For other browsers: create a link pointing to the ObjectURL containing the blob.
    const objUrl = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objUrl;
    link.download = fileName ?? "download";
    link.click();

    // For Firefox it is necessary to delay revoking the ObjectURL.
    setTimeout(() => {
      window.URL.revokeObjectURL(objUrl);
    }, 250);
  }

  private async getFile(input: RequestInfo, init?: RequestInit) {
    const response = await api.sendRequest("GET", input, init);
    if (!response.ok) {
      const responseBody = await response.text();
      throw new Error(responseBody ?? response.statusText);
    }

    const blob = await response.blob()
    const contentDispositionHeader = response.headers.get('content-disposition');
    const fileName = contentDisposition.parse(contentDispositionHeader ?? "").parameters.filename;
    return {
      fileName,
      blob
    };
  }
}

const fileDownloader = new FileDownloader();

export default fileDownloader;